import React from 'react';
import { IconProps } from '../types/types';

const SGDJPY: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 39 42" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <mask
            id="sgdjpy_svg__a"
            style={{
                maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={27}
            height={27}
        >
            <path d="M13.34 26.68c7.368 0 13.34-5.972 13.34-13.34C26.68 5.973 20.708 0 13.34 0 5.973 0 0 5.973 0 13.34c0 7.368 5.973 13.34 13.34 13.34Z" fill="#F0F0F0" />
        </mask>
        <g mask="url(#sgdjpy_svg__a)">
            <path d="M44.76-.73H0v14.86h44.76V-.73Z" fill="#ED293F" />
            <path d="M44.76 14.13H0v14.86h44.76V14.13Z" fill="#F8F8F8" />
            <path
                d="M11.908 1.467c-2.03-.693-4.224-.244-5.632 1.167C4.832 4.08 4.79 5.955 4.792 6.378c-.011.169-.145 3.181 2.328 4.909 2.14 1.495 4.498.817 4.788.73 0 0-4.839-.55-4.815-5.64 0-.002.093-4.223 4.815-4.91Z"
                fill="#fff"
            />
            <path
                d="m10.233 4.516-.276.85h-.916l.596.618-.16.894.756-.572.735.572-.276-.985.711-.527-.94.022-.23-.872ZM13.225 2.3l-.275.847h-.917l.596.62-.16.894.756-.573.734.573-.275-.986.711-.528-.94.024-.23-.872ZM16.145 4.516l-.275.85h-.917l.596.618-.16.894.756-.572.735.572-.276-.985.711-.527-.94.022-.23-.872ZM15.03 7.99l-.276.847h-.918l.598.62-.161.894.757-.574.733.574-.276-.986.71-.528-.938.024-.23-.872ZM11.358 7.99l-.276.847h-.916l.596.62-.16.894.756-.574.733.574-.274-.986.711-.528-.94.024-.23-.872Z"
                fill="#fff"
            />
        </g>
        <circle cx={24.699} cy={27.184} r={13.59} fill="#fff" stroke="#fff" strokeWidth={0.5} />
        <path d="M24.33 40.91c7.5 0 13.58-6.08 13.58-13.58s-6.08-13.58-13.58-13.58-13.58 6.08-13.58 13.58 6.08 13.58 13.58 13.58Z" fill="#F0F0F0" stroke="#fff" strokeWidth={0.5} />
        <path d="M24.33 33.126a5.796 5.796 0 1 0 0-11.592 5.796 5.796 0 0 0 0 11.592Z" fill="#D80027" />
    </svg>
);

export default SGDJPY;
